<form [formGroup]="leaseDetailService.entitySettlement" (ngSubmit)="leaseDetailService.saveSettlement()">
  <div class="grid">
    <div class="col-12">
      <div class="main-title">
        Formulario de liquidación
      </div>
    </div>
    <div class="col-12 md:col-6 xl:col-4">
      <div class="field field-flex">
        <label for="date">
          <span class="p-error">*</span>Fecha:
        </label>
        <input type="date" pInputText id="date" formControlName="date" required />
        <ng-container *ngIf="e.get('date')?.invalid && (e.get('date')?.dirty || e.get('date')?.touched)">
          <small class="p-error" *ngIf="e.get('date')?.errors?.['required']">La fecha es obligatoria.</small>
        </ng-container>
      </div>
    </div>
    <div class="col-12 md:col-6 xl:col-4">
      <app-input-single-file label="Formato de liquidación"></app-input-single-file>
    </div>
    <div class="col-12">
      <div class="field field-flex">
        <label for="comment">Comentarios:(*)</label>
        <textarea rows="5" cols="30" pInputTextarea formControlName="comment" id="comment"></textarea>
        <ng-container *ngIf="e.get('comment')?.invalid && (e.get('comment')?.dirty || e.get('comment')?.touched)">
          <small class="p-error" *ngIf="e.get('comment')?.errors?.['required']">El comentario es obligatorio.</small>
        </ng-container>
      </div>
    </div>
    <div class="col-12 text-right">
      <button pButton pRipple label="Guardar" icon="fa-solid fa-check" class="p-button-success" type="submit"></button>
    </div>
  </div>
</form>
